const reactRouter = require('./src/muster-react-router/src');
module.exports = reactRouter;
